import { useStaticQuery, graphql } from "gatsby";

const useDesktopNavigationData = () => {
  const { kontentItemNavigation } = useStaticQuery(graphql`
    query DesktopNavigation {
      kontentItemNavigation(
        system: { codename: { eq: "desktop_navigation" } }
      ) {
        elements {
          logo {
            value {
              url
            }
          }
          main_links {
            value {
              ... on kontent_item_navigation_link {
                elements {
                  external_url {
                    value
                  }
                  internal_path {
                    value
                  }
                  text {
                    value
                  }
                  new_window {
                    value {
                      codename
                    }
                  }
                }
              }
            }
          }
          secondary_links {
            value {
              ... on kontent_item_navigation_link {
                elements {
                  text {
                    value
                  }
                  internal_path {
                    value
                  }
                  external_url {
                    value
                  }
                  new_window {
                    value {
                      codename
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `);
  return kontentItemNavigation.elements;
};

export default useDesktopNavigationData;
